import getWebglVersion from '../utils/getWebglVersion';
import { getSessionSetting } from '../utils/session';

export default function isWebglAvailable() {
  return getWebglVersion() === 2 && !getSessionSetting('no3d');
}
